import React from 'react';
import { format } from 'date-fns';
import { useState, useContext, useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import FileSaver from 'file-saver';
import {MutationRegionalRevenueReportArgs, useRegionalRevenueReportMutation} from "../../generated/graphql";
import {Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, FormControlLabel, Switch} from "@mui/material";
import {CampaignStatusSelect} from "../../components/MaterialSelects/CampaignStatusSelect";
import {SalesTeamSelect} from "../../components/MaterialSelects/SalesTeamSelect";
import {IsoDatePicker} from "../../components/IsoDatePicker";
import { useToast } from "../../contexts/toast";
import {progressToast} from "../../utils/progress-toast";

const RegionalRevenueReport = () => {
    const [dateFromValue, setDateFromValue] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [dateToValue, setDateToValue] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [salesTeams, setSalesTeams] = useState([]);
    const [status,setStatus] = useState(['Confirmed','To Invoice','Part Invoiced']);
    const [isWait, setWait] = useState(false);
    const [mutation] = useRegionalRevenueReportMutation({ fetchPolicy: 'no-cache' });

    const [includeQuoteCurrency, setIncludeQuoteCurrency] = useState(false);
    const [includeClientType, setIncludeClientType] = useState(false);

    const toolbarContext = useContext(ToolbarContext);
    const {toast} = useToast();
    const updateStatus = (evt)=> {
        setStatus([...evt.target.value]);
    }
    const updateSalesTeam = (evt)=> {
        setSalesTeams([...evt.target.value]);
    }
    useEffect(() => {
        toolbarContext.setPrimary(
          {
            primary: [],
            title: 'Regional Revenue Report',
          });
      }, []);
    function setDateFrom(evt) {
        setDateFromValue(evt.target.value);
    }
    function setDateTo(evt) {
        setDateToValue(evt.target.value);
    }
    async function submitForm() {
        if (isWait) return;
        if(!dateFromValue || !dateToValue) return;
        const t = progressToast(toast)('REGIONAL_REVENUE_REPORT');
        t.start('Generating report');
        const variables:MutationRegionalRevenueReportArgs = {dateFrom: dateFromValue, dateTo: dateToValue};
        if(status.length) {
            variables.status_in = status;
        }
        if(salesTeams.length) {
            variables.salesTeam_in = salesTeams;
        }
        variables.includeQuoteCurrency = !!includeQuoteCurrency;
        variables.includeClientType = !!includeClientType;
        setWait(true);
        try {
            const data = await mutation({variables: variables});
            setWait(false);
            t.ok('Rendering file');
            const res = await fetch(data?.data?.regionalRevenueReport?.reportData);
            const blobContent = await res.blob();
            //const blobUrl = URL.createObjectURL(blobContent);
            FileSaver.saveAs(blobContent,'regional-revenue-report-'+dateFromValue+'__'+dateToValue+'.xlsx');
            //window.open(blobUrl);
        } catch (e) {
            console.log('error',e);
            t.fail('Download failed');
            setWait(false);
        }
    }
    return <div><div>
        <Accordion defaultExpanded={true}>
            <AccordionSummary>Regional Revenue Report</AccordionSummary>
            <AccordionDetails>
                <form method="POST" target="_blank">
                    <div className="grid12">
                            <IsoDatePicker className="grid12-3" name="dateFrom" value={dateFromValue} onChange={setDateFrom} label="Completion date From"/>
                            <IsoDatePicker className="grid12-3" name="dateTo" value={dateToValue} onChange={setDateTo} label="Completion date to"/>
                            <CampaignStatusSelect valueIsId={true} multiple={true} name="status" value={status} onChange={updateStatus} label="Campaign Statuses"/>
                            <SalesTeamSelect valueIsId={true} multiple={true} name="sales_team" value={salesTeams} onChange={updateSalesTeam} label="Sales Teams"/>

                                <FormControlLabel className="grid12-3"
                                    control={<Switch checked={includeQuoteCurrency} onChange={()=>{setIncludeQuoteCurrency(p=>!p)}} />}
                                    label="Include Quote Currency"
                                />
                                <FormControlLabel className="grid12-3"
                                    control={<Switch checked={includeClientType} onChange={()=>{setIncludeClientType(p=>!p)}} />}
                                    label="Include Client Type"
                                />                            

                    </div>
                </form>
            </AccordionDetails>
            <AccordionActions>
                <Button variant="contained" onClick={submitForm}>Generate Report</Button>
            </AccordionActions>
        </Accordion>
    </div></div>;
}

export default RegionalRevenueReport;